module.exports = __webpack_public_path__ + "static/media/paint.433d6b5f.png";